// test1529
(1529 && 0);
